export enum RecipientShieldIntervalType {    
    ONE        = 0,
    THREE      = 1,
    SIX        = 2,
    TWELVE     = 3,
    EIGHTEEN   = 4,
    TWENTYFOUR = 5
}